import { cn } from '@/lib/utils';
import * as React from 'react';

const Field = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} className={cn('space-y-2', className)} {...props} />;
  }
);
Field.displayName = 'Field';

const FieldLabel = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          className
        )}
        {...props}
      />
    );
  }
);
FieldLabel.displayName = 'FieldLabel';

const FieldDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  return <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />;
});
FieldDescription.displayName = 'FieldDescription';

const FieldGroup = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} className={cn('space-y-6', className)} {...props} />;
  }
);
FieldGroup.displayName = 'FieldGroup';

const FieldSeparator = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    children?: React.ReactNode;
  }
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      data-slot="field-separator"
      className={cn('relative flex items-center gap-4', className)}
      {...props}
    >
      <div className="flex-1 border-t" />
      {children && (
        <span className="text-muted-foreground text-xs" data-slot="field-separator-content">
          {children}
        </span>
      )}
      <div className="flex-1 border-t" />
    </div>
  );
});
FieldSeparator.displayName = 'FieldSeparator';

export { Field, FieldDescription, FieldGroup, FieldLabel, FieldSeparator };
